export const loginPageConfigUrl =
  process.env.REACT_APP_LOGIN_PAGE_CONFIG_URL || "https://lifeuistrapi.trilogyapps.com";

export const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LcSlnUtAAAAAIaUdIseIrh2BGXJil7cOpPVyMGN";

export const defaultConfigId = process.env.REACT_APP_DEFAULT_CONFIG_ID || "nkfukuhepqqmv637whl1nmo9";

export const dspBaseUrl = process.env.REACT_APP_BASE_URL || "https://tbndsp-prod.trilogyapps.com/v1/auth";

export const ga4StreamName = process.env.REACT_APP_GA4_STREAM_NAME || "fusionauth-login";
